<template>
  <div>

    <a-card class="all-card-style ">

      <a-form-model ref="disease" :rules="FormRules"  :model="model"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">



         <a-form-model-item label="轮灌名称"  class="ant-form-item2">
          <a-input v-model="model.cName" placeholder="请输入" :rows="3" />
        </a-form-model-item>






        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>
      <vxe-table
        style="margin-top:20px;width:100%;"
        resizable
        row-id="ID"
        :data="tableData"
        :tree-config="{children: 'children', expandAll: true}"
        :checkbox-config="{labelField:'cName',checkRowKeys:defaultExpandKeys}"
        border="inner"
        @checkbox-change="selectChangeEvent"
        @checkbox-all="selectChangeAllEvent"
      >
        <vxe-table-column type="checkbox" title="名称" tree-node ></vxe-table-column>
      </vxe-table>

    </a-card>
  </div>
</template>


<script>
  import TitleCard from '@/components/TitleCard.vue'

  export default {
    data () {
      return {
        titleMsg1: "精准灌溉",
        titleMsg2:'轮灌编制',
        titleMsg3:'轮灌编制-新增',
        titleMsg4:'轮灌编制-新增',
        model:{},
        cEntID:"",
        record:[],
        deleteModalVisible:false,
        queryInfo:{},
        tableData: [
        ],
        defaultExpandKeys: [],
        FormRules:{
          cTitle:[
            { required: true, message: '请输入灌水名称', trigger: 'blur' }
          ],
          cCropID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cCropGrowthPeriodID:[
            { required: true, message: '请选择作物生长期', trigger: 'change' }
          ],

          fArea:[
            { required: true, message: '请输入灌溉面积', trigger: 'blur' }
          ],
          dStartDate:[
            { required: true, message: '请选择开始时间', trigger: 'change' }
          ],
          dEndDate:[
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],

          fQuota:[
            { required: true, message: '请输入灌水定额', trigger: 'blur' }
          ],
          iNum:[
            { required: true, message: '请输入灌水次数', trigger: 'blur' }
          ],
        },
        queryPlatformInfo:{},
        PIDS:[],
      }
    },
    mounted () {
      let that=this;



      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.model.cEntID=that.$store.getters.User.enterprise.ID;

     if (that.$route.params.ID){
        that.model.ID=that.$route.params.ID;
        that.HandleDetail();
     }
     else{
       that.model.cGroupID=that.$route.params.cGroupID;  this.getTableData();
     }

//that.defaultExpandKeys.push('d2e15231-ff46-4ea4-a1a1-07bcc5495485');
    },

    created () {
     // this.defaultExpandKeys = ['30000']
      //  this.tableData = window.MOCK_TREE_DATA_LIST
    }
    ,
    methods:{
      selectChangeAllEvent({selection}){
        let that=this;


        that.PIDS=[];
        for(let i in selection){

          if(selection[i].iTypeID==4){

            that.PIDS.push(selection[i].ID);
          }
        }


      },
      selectChangeEvent ({ records }) {
        let that=this;
   //     console.log('     this.defaultExpandKeys s',     this.defaultExpandKeys);
     //   console.info(`勾选${records.length}个树形节点`, records)
        that.PIDS=[];
        for(let i in records){

          if(records[i].iTypeID==4){
            console.log( 'records[i].iTypeID', records[i].iTypeID);
            that.PIDS.push(records[i].ID);
          }
        }
        console.log(   '    that.PIDS', that.PIDS);
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntRotationalIrrigationSystem/FindById/' + that.model.ID, null)
console.log('     this.defaultExpandKeys g',     this.defaultExpandKeys);
        if (res.data.code == "200") {
          that.model = res.data.obj.data;
    //      this.defaultExpandKeys =that.model.defaultExpandKeys;
          let dkArr=that.model.defaultExpandKeys.split(',');
          for(let i in dkArr){
            this.defaultExpandKeys.push(dkArr[i]);
          }
        } else {

        }
        this.getTableData();
        console.log('   this.defaultExpandKeys,',   this.defaultExpandKeys);
      },
      async getTableData(){
        var _this=this
        _this.queryInfo.cEntID=_this.$store.getters.User.enterprise.ID;
        let res=await _this.$http.post('EntWLWCropWaterPipe/AllList',_this.queryInfo)

        if(res.data.code ==200){
          _this.tableData=res.data.obj.list
          if(!!     _this.tableData){
            for(let i=0;i<     _this.tableData.length;i++){
              // _this.tableData[i].rid=i+1;

              //_this.tableData[i].parentid=  _this.tableData[i].cParentID;
            }
          }


          //   _this.pagination.total=res.data.obj.listTotal

        }
        else{

        }
      },


      async SaveForms () {
        let that = this;
        let form=that.$refs['disease'];
        form.validate(async valid => {



        that.model.PipeIDS=that.PIDS.join(',');

          if (valid) {
            //url


            let res = await that.$http.post('EntRotationalIrrigationSystem/Save', that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'RotationalIrrigationSystemList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }


    },
  }
</script>
